<script setup lang="ts">
import VanillaCalendar from 'vanilla-calendar-pro';
import 'vanilla-calendar-pro/build/vanilla-calendar.min.css';
const { t } = useI18n();
const props = defineProps<{
  enabledDates: String[],
  selectedDates: String[]
}>()
const emit = defineEmits(['dateSelected'])
const options = {
  settings: {
    // selection: {
    //   day: true,
    //   month: true,
    //   year: true,
    // },
    visibility: {
      theme: 'light',
    },
    lang: 'ru-RU',
    range: {
      min: 'today',
      disableAllDays: true,
      enabled: props.enabledDates
    }
  },
  DOMTemplates: {
    default: `
      <div class="vanilla-calendar-grid">
      <div class="vanilla-calendar-header">
        <div class="vanilla-calendar-header__content">
          <#Month /> <#Year />
        </div>
        <#ArrowPrev />
        <#ArrowNext />
      </div>
      <div class="vanilla-calendar-wrapper">
        <div class="vanilla-calendar-content">
          <#Week />
          <#Days />
        </div>
      </div>
      </div>
    `,
  },
  actions: {
    clickDay(event, self) {
      emit('dateSelected', self.selectedDates[0])
    },
  },
  // locale: {
  //   months: months.value,
  //   weekday: weekDays.value,
  // }

};
if (props.selectedDates?.length) {
  options.settings.selected = {
    dates: [...props.selectedDates],
        month: parseInt(props.selectedDates[0]?.split('-')[1]) - 1,      // 0 = январь, значит 8 = сентябрь
        year: parseInt(props.selectedDates[0]?.split('-')[0]),
  }
}
onMounted(() => {
  const calendar = new VanillaCalendar('#calendar', options);
  calendar.init();
})
</script>

<template>
  <div id="calendar" class="calendar"></div>
</template>

<style scoped>
</style>